/**
 * 分 → 元字符串（不含 ¥ 符号）
 * - 整元不显示小数，并带千分位分隔（如 1,000）
 * - 非整元保留两位小数（如 12.30）
 */
export const fenToYuan = (fen: number): string => {
    const yuan = fen / 100;
    return Number.isInteger(yuan) ? yuan.toLocaleString('en-US') : yuan.toFixed(2);
};
